























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { VBPopover, BSpinner, BProgress, BFormFile, BButton } from "bootstrap-vue";
import { DemandeCapitalDeces } from "@/api/models/dossiers/demandesCapitalDeces/demandeCapitalDeces";
import RessifnetDateInput from "@/components/inputs/RessifnetDateInput.vue";
import RessifnetQuillEditor from "@/components/inputs/RessifnetQuillEditor.vue";

@Component({
  components: {
    BSpinner,
    BButton,
    BProgress,
    BFormFile,
    RessifnetDateInput,
    RessifnetQuillEditor
  },
  directives: {
    'b-popover': VBPopover
  },
  name: "dossier-demandes-capital-deces"
})
export default class DossierDemandesCapitalDeces extends Vue {
  loading: boolean = true

  demandeEdited: DemandeCapitalDeces = {};
  fichiersUploaded: any[] = [];
  percentUpload: number = 0;
  
  onUploadProgress(percent: any) {
    this.percentUpload = percent;
  }

  async created() {
    await this.loadDemandeCapitalDeces();
  }

  get fichiers() {
    var files = [];

    if (this.demandeEdited.fichiers && this.demandeEdited.fichiers.length > 0) {
      files = this.demandeEdited
        .fichiers.filter((f: any) => f.id == undefined)
        .map(
          (x: File) =>
            <any>{
              nom: x.name,
            }
        );
    }
    
    return files.concat(this.fichiersUploaded);
  }

  closeDetails() {
    this.demandeEdited = {
      fichiers : []
    }
    this.$emit('close-details')
  }
  
  async downloadFile(fichier:any) {
    if (!fichier.id)
      return;
    else {
      await this.$http.ressifnet.fichiersDossiers
        .downloadFile(fichier.id)
        .then(
          async (response: any) => {
            window.open(response);
          },
          (error: any) => {
            if (error?.response?.data?.errors) {
              errorAlert.fire({
                text: error.response.data.errors[
                  Object.keys(error.response.data.errors)[0]
                ],
              });
            } else {
              errorAlert.fire({
                text: error.message,
              });
            }
          }
        );
    }
  }
  async loadDemandeCapitalDeces() {
    this.loading = true
    await this.$http.ressifnet.demandesCapitalDeces.get(this.$route.params.id)
      .then(
        (response: any) => {
          if (response != '')
            this.demandeEdited = response
          this.loading = false

          this.fichiersUploaded = this.demandeEdited?.fichiers ?? []
          this.demandeEdited.fichiers = [] 
        }, (error: any) => {
          errorAlert.fire({
            title: 'Erreur lors du chargement de la demande de capital décès'
          })
        }
      )
  }
  async save(callback: any) {
    let config = {
      onUploadProgress(progressEvent: any) {
        var percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );

        callback(percentCompleted);
        return percentCompleted;
      },
    };

    await this.$http.ressifnet.demandesCapitalDeces
      .put(this.$route.params.id, this.demandeEdited, config)
      .then(
        (response: any) => {
          this.$emit('reloadDossier');
          this.$emit('reloadNotes');
          this.$emit('reloadFiles');
          successAlert.fire({
            title: "Modification d'une demande de capital décès",
            text: "Modification effectué avec succès",
          });
          this.percentUpload = 0;
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
          this.percentUpload = 0;
        }
      )
      .finally(async() => {
        await this.loadDemandeCapitalDeces()
      });
  }

  removeFichier(fichier: any) {
    if (fichier.id != undefined) {
      this.$bvModal
        .msgBoxConfirm(
          "Etes-vous sûr de vouloir supprimer ce fichier de la demande de capital décès ? Cela le supprimera directement",
          {
            title: "Confirmation de suppression",
            size: "sm",
            okVariant: "primary",
            okTitle: "Oui",
            cancelTitle: "Non",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then(async (value) => {
          if (value === true) {
            this.confirmRemoveFichier(fichier);
          } else {
            return;
          }
        });
    } else {
      this.demandeEdited.fichiers!.splice(
        (this.demandeEdited.fichiers! as any[]).indexOf(fichier),
        1
      );
    }
  }

  async confirmRemoveFichier(fichier: any) {
    await this.$http.ressifnet.demandesCapitalDeces
      .deleteFile(
        this.$route.params.id,
        (this.demandeEdited as any).id,
        fichier.id
      )
      .then((res: any) => {
        this.$emit('reloadDossier');
        this.loadDemandeCapitalDeces()
        successAlert.fire({
          title: "Suppression d'un document",
          text: "Suppression effectuée avec succès",
        });

        (this.demandeEdited.fichiers! as any[]).push({ id: fichier.id });
        this.fichiersUploaded.splice(
          (this.fichiersUploaded as any[]).indexOf(fichier),
          1
        );
      });
  }
}
